<template>

        <div class="row match-height">
            <div class=" col-12 col-md-8 card-separator">
                <div class="card">
                    <div class="card-body">
                        <h3>Welcome back, {{ userStore.user.full_name }} 👋🏻 </h3>
                        <p>Your progress this week is Awesome. let's keep it up and get a lot of points reward !</p>
                        <div class="row">
                            <div class="col-md-4 d-flex align-items-center  flex-wrap gap-3">
                                <span class="bg-label-primary p-1 rounded mr-2">
                                    <vue-feather type="monitor"></vue-feather>
                                </span>
                                <div class="">
                                    <p class="mb-0">Hours Spent</p><h4 class="text-primary mb-0">{{ convertSecToTime(totalWatch) }}</h4>
                                </div>
                            </div>
                            <div class="col-md-4 d-flex align-items-center  flex-wrap gap-3">
                                <span class="bg-label-primary p-1 rounded mr-2">
                                    <vue-feather type="video"></vue-feather>
                                </span>
                                <div class="">
                                    <p class="mb-0">Total Courses</p><h4 class="text-primary mb-0">{{userStore.user.owned_courses}}</h4>
                                </div>
                            </div>
                            <div class="col-md-4 d-flex align-items-center  flex-wrap">
                                <span class="bg-label-primary p-1 rounded mr-2">
                                    <vue-feather type="award" class="trello"></vue-feather>
                                </span>
                                <div class="">
                                    <p class="mb-0">Course Completed</p><h4 class="text-primary mb-0">{{userStore.user.completed_courses}}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4 card-separator">
                <div class="card">
                    <div class="card-body">
                        <div class="" v-if="userStore.user.has_course_membership && !userStore.user.course_subscription_lifetime && userStore.user && userStore.profile">
                            <div v-if="userStore.profile && userStore.profile.course_sub_details && userStore.profile.course_sub_details.canceled !=true">
                                <div class="d-flex justify-content-between align-items-start mb-1">
                                    <span class="badge bg-light-warning text-sm" style="font-size:11px;" v-if="userStore.profile.course_sub_details.user_subscription_ended">
                                        {{ userStore.user.my_course_membership }}
                                    </span>
                                    <template v-else>
                                        <span class="badge bg-light-primary text-sm" style="font-size:11px;" >{{userStore.user.my_course_membership}}</span>
                                        <div>
                                            <sup class="h5 pricing-currency text-primary mt-0 mb-0"></sup>
                                            <span class="display-5 mb-0 text-primary" style="font-weight:bolder;" v-if="userStore.profile.course_sub_details">{{userStore.profile.course_sub_details.amount}}</span>
                                            <span>/</span>
                                            <span v-if="userStore.user.course_membership.slug != 'course_annually'">month</span>
                                            <span v-else>Year</span>
                                        </div>
                                    </template>

                                </div>
                                <div class="d-flex justify-content-start mb-1" v-if="!userStore.profile.course_sub_details.user_subscription_ended">
                                    <span class="badge bg-light-primary text-sm" style="font-size:11px;" v-if="userStore.profile.course_sub_details.course_plan">{{userStore.profile.course_sub_details.course_plan.title}}</span>
                                </div>
                                <ul class="ps-1 mb-2">
                                    <li class="mb-50" v-if="userStore.profile.course_sub_details.canceled">
                                        <h5 v-if="userStore.profile.nextCoursePaymentAttempt !== 0" style="font-weight:bolder;">
                                            Subscription ends on {{userStore.profile.nextCoursePaymentAttempt}}
                                        </h5>
                                        <h5 v-else style="font-weight:bolder;">
                                            Subscription Is Inactive
                                        </h5>
                                    </li>
                                    <li class="mb-50" style="list-style-type:none;" v-else><h5 style="font-weight:bolder;list-style-type:none;">Plan Renews On {{userStore.profile.nextCoursePaymentAttempt}}</h5></li>
                                    <!-- <li class="mb-50">We will send you a notification upon subscription expiration</li> -->
                                </ul>
                                <div class="d-flex justify-content-between align-items-center fw-bolder mb-50">
                                    <span>Days</span>
                                    <span>{{userStore.profile.course_sub_details.subDifference}} of {{userStore.profile.course_sub_details.totalDay}} Days</span>
                                </div>
                                <div class="progress mb-50" style="height: 8px">
                                    <div class="progress-bar" role="progressbar" :style="{width:userStore.profile.course_sub_details.percentageDate+'%'}" aria-valuenow="65" aria-valuemax="100" aria-valuemin="80"></div>
                                </div>
                                <span v-if="userStore.profile.course_sub_details.canceled">Subscription Has Ended.</span>
                                <!-- <span v-else-if="userStore.profile.canceled==''">{{paymentBar.remainingDate}} days remaining until renewal.</span> -->
                                <span v-else>
                                    <span v-if="userStore.profile.course_sub_details.remainingDate > 0">{{userStore.profile.course_sub_details.remainingDate}} days remaining until renewal</span>
                                    <span v-else>Subscription Has Ended.</span>
                                </span>
                                <div class="d-grid w-100 mt-2">
                                    <button
                                        class="btn btn-light waves-effect waves-float waves-light col-12"
                                        @click="ResumeCourseSubscription()"
                                        v-if="userStore.profile.course_sub_details.canceled"
                                    >
                                        Resume Subscription
                                    </button>
                                    <div v-else>
                                        <div>
                                            <a
                                                href="javascript:void(0)"
                                                class="btn btn-outline-danger suspend-user waves-effect mr-2 mb-2"
                                                data-target="#deactivate-reason-modal"
                                                data-toggle="modal"
                                                @click="cancelCourseSubscription"
                                            >
                                                Cancel My Subscription
                                            </a>
                                            <a
                                                href="javascript:void(0)"
                                                aria-current="page"  class="btn btn-outline-primary suspend-user waves-effect mb-2" target="_self"
                                                @click="openModal('#subscription')"
                                            >
                                                <span class="menu-title text-truncate">{{ localizationStore.translate('billing') }}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <template v-if="userStore.profile">
                                    <h4 class="mb-2" style="font-weight:bolder;">
                                        Canceled Subscription
                                    </h4>
                                    <div class="d-flex justify-content-between align-items-start mb-1">
                                        <span class="badge bg-light-primary text-sm" style="font-size:11px;">{{ userStore.user.my_course_membership }}</span>
                                    </div>
                                    <div class="d-flex justify-content-start mb-1">
                                        <sup class="h5 pricing-currency text-primary mt-0 mb-0"></sup>
                                        <span class="display-5 mb-0 text-primary" style="font-weight:bolder;" v-if="userStore.profile && userStore.profile.course_sub_details">{{ userStore.profile.course_sub_details.amount }}</span>
                                        <span>/</span>
                                        <span v-if="userStore.user.course_membership.slug != 'course_annually'">month</span>
                                        <span v-else>Year</span>
                                    </div>
                                    <h5 style="font-weight:bolder;">
                                        Your Subscription Ends On:
                                    </h5>
                                    <h6>
                                        <span v-if="userStore.profile">
                                            {{formatDate(userStore.profile.courseEndsAt,'llll')}}
                                        </span>

                                    </h6>
                                    <button
                                        class="btn btn-light waves-effect waves-float waves-light col-12 mt-2"
                                        @click="ResumeCourseSubscription()"
                                        v-if="userStore.profile.course_sub_details.canceled"
                                    >
                                        Resume Subscription
                                    </button>
                                </template>
                            </div>

                        </div>
                        <div class="" v-else-if="userStore.user.course_subscription_lifetime">
                            <h4 class="text-primary mb-1 mt-2">{{ userStore.user.course_subscription_lifetime.name }}</h4>
                            <div class="">
                                <p class="text-body w-sm-80 app-academy-xl-100">
                                <span v-html="userStore.user.course_subscription_lifetime.plan_details.plan_description"></span>
                                </p>
                            </div>
                            <div class="text-center">
                                <div class="d-flex">
                                <sup class="h6 pricing-currency mt-0 mb-0 me-1 text-primary">$</sup>
                                <h1 class="text-primary">{{userStore.user.course_subscription_lifetime.plan_details.plan_price}}</h1>
                                </div>
                            </div>
                            <button type="button" class="btn btn-primary waves-effect waves-light" > Purchased </button>
                            <a
                                href="javascript:void(0)"
                                aria-current="page"  class="btn btn-outline-primary suspend-user waves-effect ml-2" target="_self"
                                @click="openModal('#subscription')"
                            >
                                <span class="menu-title text-truncate">{{ localizationStore.translate('billing') }}</span>
                            </a>
                        </div>
                        <div class="" v-else>
                            <h5 class="text-primary mb-1 mt-2">Maximize Your Creditfixrr Experience!</h5>
                            <small class="text-muted mb-1">
                                Become a member of the Creditfixrr Academy: You get Access to all courses & content, watch videos at your pace, and download resources for an enriched learning experience. Take control of your education now!
                            </small>
                            <br>
                            <button type="button" class="btn btn-primary waves-effect waves-light mt-2 mb-2" @click="openModal('#subscription')"> Subscribe Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        
    <div class="row">
        <div class="col-12 col-md-3 card-separator" v-for="(webiner,index) in webiners" :key="index">
            <div class="card h-100">
                <div class="card-body">
                    <div class="bg-label-primary rounded-3 text-center mb-1">
                    <img class="img-fluid" :src="webiner.image_url" alt="Card girl image">
                    </div>
                    <h4 class="">{{webiner.title}}</h4>
                    <p class="small">{{webiner.description}}</p>
                    <div class="row mb-3">
                    <div class="mt-1 ml-1">
                        <div class="d-flex">
                            <span class="bg-label-primary p-1 rounded mr-2">
                                <vue-feather type="video"></vue-feather>
                            </span>
                            <div class="">
                                <h6 class="mt-1 text-nowrap">{{webiner.time}}</h6>
                                <small>Duration</small>
                            </div>
                        </div>
                    </div>
                    </div>
                    <span v-html="webiner.embeded"></span>
                </div>
                </div>
        </div>
    </div>
    <div class="card mt-4">
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-sm-12 d-flex justify-content-between">
                    <h3>Course you are taking</h3>
                    <form  class="form-group">
                        <input type="text" class="form-control" v-model="searchitem" placeholder="Search For My Courses"  @keyup="debouncedSearchCourses">
                    </form>
                </div>

                <div class="col-12 col-md-12 card-separator">
                    <vue-good-table
                        mode="remote"
                        v-on:page-change="onPageChange"
                        v-on:per-page-change="onPerPageChange"
                        v-on:selected-rows-change="selectedOptions"
                        :totalRows="totalRecords"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                            enabled: true,
                            perPageDropdown: [10, 20, 30, 40, 50, 100],
                            dropdownAllowAll: false,
                            perPageDropdownEnabled: true,
                        }"
                        :rows="rows"
                        :columns="columns"
                        :sort-options="{
                            enabled: false
                        }"
                        :select-options="{
                            enabled: false,
                            selectOnCheckboxOnly: true
                        }"
                        styleClass="vgt-table striped"

                        ref="academy"
                    >
                        <!-- for business users -->
                        <template #table-row="props">
                            <span v-if="props.column.field == 'slug'">
                                <h5>{{props.row.title}}</h5>
                                <div class="d-flex align-items-center">
                                    <div class="cf-avatar text-primary" >
                                            {{abbreviateName(props.row.author_name)}}
                                    </div>
                                    <div class="ml-1 font-weight-normal">
                                        {{ props.row.author_name }}
                                    </div>
                                </div>

                            </span>
                            <span v-if="props.column.field == 'total_hours'">
                                <p style="font-family: sans-serif;height: 40px;line-height: 40px;">{{convertSecToTime(props.row.total_hours)}}</p>
                            </span>
                            <span v-if="props.column.field == 'user_watch_time'">
                                <div class="d-flex" style="height:40px;line-height:40px">
                                    <div>
                                        {{courseProgress(props.row.user_watch_time,props.row.total_hours)}}%
                                    </div>
                                    <div class="progress mb-4" style="height: 8px;width: 150px;margin-top: 15px;margin-left: 10px;">
                                        <div class="progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" :style="{ width: courseProgress(props.row.user_watch_time,props.row.total_hours) + '%' }" ></div>
                                    </div>
                                    <div class="ml-1">
                                        100%
                                    </div>

                                </div>

                            </span>
                            <span v-if="props.column.field == 'students'" data-toggle="tooltip" data-placement="top" title="Total Students Taking The Course">
                                <div class="d-flex justify-content-center" style="height:40px;line-height:40px">
                                    <p style="margin-top: 13px;"><vue-feather class="text-primary" type="users" size="18" ></vue-feather></p>
                                    <p style="margin-top: 12px;margin-left: 6px;">{{ props.row.students}}</p>
                                </div>

                            </span>
                            <span v-if="props.column.field == 'total_lessons'" data-toggle="tooltip" data-placement="top" title="Total Lectures ">
                                <div class="d-flex justify-content-center" style="height:40px;line-height:40px">
                                    <p style="margin-top: 13px;"><vue-feather class="text-secondary" type="book-open" size="18" ></vue-feather></p>
                                    <p style="margin-top: 12px;margin-left: 6px;">{{ props.row.total_lessons }}</p>
                                </div>
                            </span>
                            <span v-if="props.column.field == 'total_course_video'" data-toggle="tooltip" data-placement="top" title="Total Video ">
                                <div class="d-flex justify-content-center" style="height:40px;line-height:40px">
                                    <p style="margin-top: 13px;"><vue-feather class="text-warning" type="video" size="18" ></vue-feather></p>
                                    <p style="margin-top: 12px;margin-left: 6px;">{{ props.row.total_course_video }}</p>
                                </div>
                            </span>
                        </template>

                        <!-- end of to do -->
                    </vue-good-table>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade text-left" id="subscription" tabindex="-1" aria-labelledby="myModalLabel17"
            style="padding-right: 15px;" aria-modal="true" role="dialog">

        <div class="modal-dialog modal-lg modal-simple modal-pricing" role="document">
            <div class="modal-title">
                <button @click="closeModal(`#subscription`)" type="button" class="close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-content">
                <h3 class="text-center mt-4">Subscription Plans</h3>
                <p class="text-center mb-4">Premium membership grants limitless access.</p>
                    <div class="row">
                        <!-- Basic -->
                        <div class="col-lg-1"></div>
                            <div class="col-lg-9">
                                <div class="row">
                                    <div class=" mb-md-0 mb-4" v-for="(plan,index) in planStore.coursePlan" :key="index" :class="{'col-sm-6':plan.slug !== 'course_lifetime','col-sm-12':plan.slug == 'course_lifetime'}" v-if="userStore.user && userStore.profile">
                                        <div class="card border rounded shadow-none" :class="{'active-border-plan':userStore.user.course_membership && (userStore.user.course_membership.slug == plan.slug)}" v-if="plan.slug !== 'course_lifetime'">
                                            <div class="card-body" :class="{'position-relative':userStore.user.course_membership && (userStore.user.course_membership.slug == plan.slug)}">
                                            <div class="position-absolute end-0 me-4 top-0 mt-4" v-if="userStore.user.course_membership && (userStore.user.course_membership.slug == plan.slug)">
                                                <span class="badge bg-label-primary">Active Plan</span>
                                            </div>
                                            <div class="position-absolute end-0 me-4 top-0 mt-4" v-else-if="plan.slug == 'course_annually'">
                                                <span class="badge bg-label-primary">Popular</span>
                                            </div>
                                            <!-- <div class="my-3 pt-2 text-center">
                                                <img class="course-subscription-img" :src="plan.plan_image" alt="Basic Image" height="140">
                                            </div> -->
                                            <template  v-if="plan.slug == 'course_monthly'">
                                                <h3 class="card-title text-center text-capitalize mb-1">Monthly</h3>
                                                <p class="text-center">Access to everything</p>
                                            </template>
                                            <template  v-if="plan.slug == 'course_annually'">
                                                <h3 class="card-title text-center text-capitalize mb-1">Yearly</h3>
                                                <p class="text-center">Best value</p>
                                            </template>
                                            <template  v-if="plan.slug == 'course_lifetime'">
                                                <h3 class="card-title text-center text-capitalize mb-1">Lifetime</h3>
                                                <p class="text-center">Access forever</p>
                                            </template>

                                            <div class="text-center">
                                                <div class="d-flex justify-content-center">
                                                <sup class="h6 pricing-currency mt-3 mb-0 me-1 text-primary">$</sup>
                                                <h1 class="display-4 mb-0 text-primary">{{plan.plan_price}}</h1>
                                                <sub class="h6 pricing-duration mt-auto mb-2 text-muted fw-normal" v-if="plan.slug == 'course_monthly'">/month</sub>
                                                <sub class="h6 pricing-duration mt-auto mb-2 text-muted fw-normal" v-if="plan.slug == 'course_annually'">/annually</sub>
                                                <sub class="h6 pricing-duration mt-auto mb-2 text-muted fw-normal" v-if="plan.slug == 'course_lifetime'">/lifetime</sub>
                                                </div>
                                            </div>

                                            <span v-html="plan.plan_description"></span>
                                                <template v-if="userStore.profile && userStore.profile.user">
                                                    <a href="#" class="btn btn-primary d-grid w-100 waves-effect" v-if="userStore.user.course_membership && (userStore.user.course_membership.slug == plan.slug)">Subscribed</a>
                                                    <a href="#" class="btn btn-label-success d-grid w-100 waves-effect" style="background: #ebebeb;" v-else-if="userStore.profile.user.has_course_membership && userStore.profile.user.course_membership && userStore.profile.user.course_membership.slug !== plan.slug" @click="swapPlan(plan.slug,plan.title)">Swap Plan</a>
                                                    <a href="#" class="btn btn-label-success d-grid w-100 waves-effect" v-on:click="openModal(`#${coursesElement}`,changeSubType(plan.slug))" style="background: #ebebeb;" v-else-if="!userStore.user.course_subscription_lifetime">Subscribe</a>
                                                    <a href="#" class="btn btn-label-success d-grid w-100 waves-effect" style="background: #ebebeb;" v-else>Not Active</a>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="card" style="height:90% !important" v-else>
                                            <div class="card-body d-flex justify-content-between flex-wrap-reverse">
                                                <div class="mb-0 app-academy-sm-60 d-flex flex-column justify-content-between text-sm-start">
                                                <div class="">
                                                  <h4 class="text-primary mb-1" style="text-align: justify;">{{plan.title}}</h4>
                                                  <p class="text-body w-sm-80 app-academy-xl-100">
                                                    <span v-html="plan.plan_description"></span>
                                                  </p>
                                                </div>
                                                <div class="text-center">
                                                    <div class="d-flex">
                                                    <sup class="h6 pricing-currency mt-3 mb-0 me-1 text-primary">$</sup>
                                                    <h1 class="display-4 mb-0 text-primary">{{plan.plan_price}}</h1>
                                                    <sub class="h6 pricing-duration mt-auto mb-2 text-muted fw-normal" v-if="plan.slug == 'course_lifetime'">/lifetime</sub>
                                                    </div>
                                                </div>
                                                <div class="mb-0">
                                                    <a href="#" class="btn btn-primary  waves-effect waves-light"  v-if="userStore.user.course_subscription_lifetime">Purchased</a>
                                                    <a href="#" class="btn btn-label-success  waves-effect waves-light" style="background: #ebebeb;"  @click="openModal(`#${coursesElement}`),changeSubType(plan.slug)" v-else>Get Lifetime Plan</a>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                    </div>
                                </div>
                            </div>
                        <div class="col-lg-1"></div>
                    </div>
                </div>
        </div>
    </div>
    <payment-modal
    :id="coursesElement"
    :plan-slug="selectedOption"
    :intent="intent"
    :subscriptionType="1"

    >
        <template #header>
            <div class="d-flex">
                <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/best-diy-credit-repair-software-official-logo.png" class="mb-2 w-50 mx-auto" alt="creditfixrr">
            </div>
            <h3 class="text-primary text-center mb-1">
                Start Your Course Subscription Now
            </h3>
            <p>

            </p>
            <div v-if="error" class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                <div class="alert-body">
                    <i data-feather="info" class="mr-50 align-middle"></i>
                    <span v-html="message"></span>
                </div>
            </div>
            <template v-if="selectedOption == 'course_monthly'">
                <input
                    type="radio"
                    name="plan"
                    v-model="selectedPlan"
                    :value="planStore.getCoursesPlans('course_monthly', 'slug')"
                    id="plan-one"
                    class="custom-control-input"
                />
                <label for="plan-one" class="card radio-box mb-50">
                    <div class="card-body p-75">
                        <div class="d-flex justify-content-between flex-wrap">
                            <h6 class="font-weight-bolder mb-0">
                                {{ planStore.getCoursesPlans('course_monthly', "title") }}
                            </h6>
                            <h6 class="font-weight-bolder mb-0">
                                $ {{ planStore.getCoursesPlans('course_monthly', "plan_price") }}
                            </h6>
                        </div>
                    </div>
                </label>
            </template>
            <template v-else-if="selectedOption == 'course_annually'">
                <input
                    type="radio"
                    name="plan"
                    v-model="selectedPlan"
                    :value="planStore.getCoursesPlans('course_annually', 'slug')"
                    id="plan-one"
                    class="custom-control-input"
                />
                <label for="plan-one" class="card radio-box mb-50">
                    <div class="card-body p-75">
                        <div class="d-flex justify-content-between flex-wrap">
                            <h6 class="font-weight-bolder mb-0">
                                {{ planStore.getCoursesPlans('course_annually', "title") }}
                            </h6>
                            <h6 class="font-weight-bolder mb-0">
                                $ {{ planStore.getCoursesPlans('course_annually', "plan_price") }}
                            </h6>
                        </div>
                    </div>
                </label>
            </template>
            <template v-else-if="selectedOption == 'course_lifetime'">
                <input
                    type="radio"
                    name="plan"
                    v-model="selectedPlan"
                    :value="planStore.getCoursesPlans('course_lifetime', 'slug')"
                    id="plan-one"
                    class="custom-control-input"
                />
                <label for="plan-one" class="card radio-box mb-50">
                    <div class="card-body p-75">
                        <div class="d-flex justify-content-between flex-wrap">
                            <h6 class="font-weight-bolder mb-0">
                                {{ planStore.getCoursesPlans('course_lifetime', "title") }}
                            </h6>
                            <h6 class="font-weight-bolder mb-0">
                                $ {{ planStore.getCoursesPlans('course_lifetime', "plan_price") }}
                            </h6>
                        </div>
                    </div>
                </label>
            </template>


        </template>
        <template #footer="{ subscribeCourse,SubscribeCourseOneTime }">
            <div class="row gy-1 gx-2 mt-75">
                <div class="col-12 text-center">
                    <button type="button" @click.once="subscribeCourse" class="btn btn-primary mr-1 mt-1" :key="planStore.paymentBtnKey" v-if="selectedOption !== 'course_lifetime'">
                        Start Membership
                    </button>
                    <button type="button" @click.once="SubscribeCourseOneTime" class="btn btn-primary mr-1 mt-1" :key="planStore.uniqueKeyBtn" v-else>
                        Start Membership
                    </button>
                    <button @click="closeModal(`#${coursesElement}`)" type="reset" class="btn btn-outline-secondary mt-1 modal-close-btn" data-dismiss="modal" aria-label="Close">
                        {{ localizationStore.translate("card.modal.button.cancel") }}
                    </button>
                </div>
            </div>
        </template>
    </payment-modal>
</template>
<script>
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useBusinessStore } from '../../stores/BusinessStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import { usePlanStore } from '../../stores/PlanStore.js'
    import { ref, reactive, computed } from 'vue'
    import Loader from '../report/Loader.vue'
    import { openModal,closeModal,abbreviateName,convertSecToTime,formatDate } from '../../utilities/_helpers'
    import 'vue-good-table-next/dist/vue-good-table-next.css'
    import { VueGoodTable } from 'vue-good-table-next';
    import { useRoute, useRouter } from 'vue-router'
    import PaymentModal from '../modals/PaymentComponent'
    import Swal from 'sweetalert2'
    export default {
        components:{
            'loading': Loader,
            VueGoodTable,
            PaymentModal
        },
        watch: {
            'userStore.user'(value) {
                if (value != null) {
                    this.clientEmail = value.email;
                }
            },
            'planStore.planData'(value){
                this.intent = value.intent.client_secret
            }
        },
        props: {
            invoice: {
                type: [Array, Object]
            }
        },
        setup() {
            const router = useRouter(),
            route = useRoute(),
            searchitem=ref(),
            url = router.resolve(
                {
                    name:'courses',
                    query: {
                        page: '1',
                        type:'user-courses'
                    },
                }
            );
            return {
                localizationStore: useLocalizationStore(),
                businessStore: useBusinessStore(),
                convertSecToTime:convertSecToTime,
                reportStore: useReportStore(),
                abbreviateName:abbreviateName,
                userStore: useUserStore(),
                planStore:usePlanStore(),
                clientEmail: ref(null),
                totalWatch:ref(),
                openModal: openModal,
                formatDate:formatDate,
                closeModal:closeModal,
                coursesElement:'courses-plan',
                selectedOption:ref(null),
                webiners:ref([]),
                isLoading: ref(true),
                currentPage: url.href,
                courses: ref([]),
                intent:ref(null),
                searchitem,
                router,
                route,

            }
        },
        data(){
            return{
                columns: [
                    {
                        label: 'Course Name',
                        field: 'slug',
                    },
                    {
                        label: 'Time',
                        field: 'total_hours',
                        type: 'string',
                    },
                    {
                        label: 'Progress',
                        field: 'user_watch_time',
                        type: 'string',
                    },
                    {
                        label: '',
                        field: 'students',
                        type: 'string',
                    },
                    {
                        label: '',
                        field: 'total_lessons',
                        type: 'string',
                    },
                    {
                        label: '',
                        field: 'total_course_video',
                        type: 'string',
                    }
                ],
                rows: [],
                totalRecords: 0,
                limit:10,
                page:0,

            }
        },
        computed: {
            debouncedSearchCourses() {
                return _.debounce(this.onSearch, 1000);
            },
        },
        mounted(){
            if(!_.isEmpty(this.planStore.planData)){
                this.intent = this.planStore.planData.intent.client_secret
            }
            this.getCourses(this.currentPage,null)
            this.getWebiners()
        },
        methods:{
            getCourses(uri,page){
                this.page++;
                let $this = this,url;
                url = uri + '&limit='+this.limit
                axios.get(url).then(function(response) {
                    $this.courses = response.data.data;
                    $this.rows = $this.courses.data;
                    $this.totalRecords = $this.courses.total;
                    $this.isLoading = false;
                    $this.totalWatch = _.sumBy($this.rows, 'user_watch_time');

                }).catch(function(error) {
                    $this.rows = [];
                    $this.totalRecords = 0;
                    $this.isLoading = false;
                });
            },
            onPageChange(params) {
                let global_data = this.courses.data.data;
                if (params.prevPage < params.currentPage) { // Next
                    this.currentPage = global_data.next_page_url;
                    this.getCourses(global_data.next_page_url, true);
                }
                else { // Previous
                    this.currentPage = global_data.prev_page_url;
                    this.getCourses(global_data.prev_page_url, true);
                }
            },
            onPerPageChange(params) {
                let global_data = this.courses.data.data;
                let links = global_data.links,activeLink;
                links.forEach(element => {
                    if(element.active == true){
                        activeLink =element.url
                    }else{
                        const route = this.$router.resolve(
                            {
                                name:'courses',
                                query: {
                                    page: '1',
                                    type:'user-courses'
                                },
                            }
                        );
                        activeLink = route.href
                    }
                });
                this.limit = params.currentPerPage
                this.getCourses(activeLink, true);
            },
            selectedOptions(){

            },
            onSearch(){
                let $this = this;
                if(!_.isNull(this.searchitem)){
                    var payload = {
                        searchTerm: this.searchitem
                    }
                    axios.post(this.currentPage,payload).then((response)=>{
                        if(response.data.error == false){
                            $this.courses = response.data.data;
                            $this.rows = $this.courses.data;
                            $this.totalRecords = $this.courses.total;
                            $this.isLoading = false;
                        }else{
                            $this.rows = [];
                            $this.totalRecords = 0;
                        }
                    }).catch(()=>{
                        $this.rows = [];
                        $this.totalRecords = 0;
                    })
                }else{
                    this.getCourses(this.currentPage ,true);
                }

            },
            courseProgress(userWatchTime,totalHours) {
                const percentage = (userWatchTime / totalHours) * 100;
                return Math.round(percentage);
            },
            getWebiners(){
                let $this = this;
                const route = this.$router.resolve({
                    name:'courses-webiner',

                });
                axios.post(route.href).then((response)=>{
                    $this.webiners = response.data.data;
                }).catch(()=>{

                })

            },
            changeSubType(element){
                this.selectedPlan = element;
                this.selectedOption = element;
                this.planStore.planSlug = element;
            },
            cancelCourseSubscription(){
                let $this = this;
                const route = this.$router.resolve({
                    name:'cancel-course-subscription',
                });
                Swal.fire({
                    title: 'Are you sure you want to cancel the '+$this.userStore.user.course_membership.title + ' plan.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Cancel!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        axios.post(route.href)
                        .then(function (response) {
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            toastr.success(response.data.message, 'Success!');
                            setTimeout(() => {window.location.reload();}, 3000)
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                    }
                });
            },
            swapPlan(slug,toSwap){
                let $this = this;
                const route = this.$router.resolve({
                    name:'swap-course-subscription',
                });
                let payload = {
                    plan:slug
                }
                Swal.fire({
                    title: 'Are you sure you want to swap to '+toSwap + ' plan.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes swap!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        axios.post(route.href,payload)
                        .then(function (response) {
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            toastr.success(response.data.message, 'Success!');
                            setTimeout(() => {window.location.reload();}, 3000);
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                    }
                });
            },
            ResumeCourseSubscription(){
                let $this = this;
                const route = this.$router.resolve({
                    name:'resume-course-subscription',
                });
                Swal.fire({
                    title: 'Are you sure you want to Resume '+$this.userStore.user.course_membership.title,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Resume!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        axios.post(route.href)
                        .then(function (response) {
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            toastr.success(response.data.message, 'Success!');
                            setTimeout(() => {window.location.reload();}, 3000)
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                    }
                });
            },
        }
    }
</script>
<style>
.cf-avatar{
    height: 30px;
    width: 31px;
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    border: 1px solid green;
    font-size: 11px;
}
.swal2-container.swal2-center {
    align-items: center;
    z-index: 2323233232323;
}
</style>
